import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { AirportService } from '@shared/components/airport/airport.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export function validAirportCode(airportService:AirportService): AsyncValidatorFn {
    return (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
      return airportService.searchAirports(control.value.toUpperCase()).pipe(map(
        res => {
            const result = res.filter(airportData => airportData.code === control.value.toUpperCase());
            return (result.length <= 0) ? { 'invalidCode': true } : null;
        }
      ));
    };
}
